export default __webpack_public_path__ + "static/media/(93).bf830499.jpg";